import http from "../http";

function kmcTrCert(randomStr, type) {
  return http(
    "GET",
    `${window.API_URL}/kmc/certification/base?certNum=${randomStr}&urlType=${type}`
  );
}

export default {
  kmcTrCert,
};
